import { Box } from "@mui/material";
import LandingHeader from "./Header";
import LandingFooter from "./Footer";

const LandingMain = (props: any = null) => {
  return (
    <>
      <Box className="livis-auth-main">
        <div className="livis-auth-header-wrap">
          <LandingHeader landing_page_props={props.landing_page_props} />
        </div>
        {/* Put wrapper for children for height */}
        <div className="livis-main-body-wrap">{props.children}</div>
        <div className="livis-main-footer-wrap">
          <LandingFooter />
        </div>
      </Box>
    </>
  );
};

export default LandingMain;
